module.exports = "pegasus/assets/blocks/social-1-basic.png";